import ProteinPremiumMarkets from "pages/ProteinPremiumMarkets";

export default function ProteinPremiumMarketsPage() {
  return <ProteinPremiumMarkets />;
}
